export const delay = async (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const BASE_URL = `${window.location.protocol}//${window.location.host}`;

export const shortAmount = (x: number | null | undefined) => {
  if (x === null || x === undefined) return x;
  const sign = x < 0 ? '-' : '';
  const absX = Math.abs(x);
  const body = Math.floor(
    absX >= 1_000_000 ? absX / 1_000_000 : absX >= 1_000 ? absX / 1_000 : absX
  );
  const suffix = absX >= 1_000_000 ? 'M' : absX >= 1_000 ? 'K' : '';
  const currency = '$';
  return `${sign}${currency}${body}${suffix}`;
};
